// Main component
export { MantineDataTable } from './MantineDataTable'

// Types - re-export TanStack types and our extensions
export type {
  // Our Mantine-specific types
  MantineDataTableProps,
  MantineTableStyleProps,
  // TanStack types (re-exported for convenience)
  ColumnDef,
  SortingState,
  PaginationState,
  RowSelectionState,
  ColumnPinningState,
  Row,
  Updater,
  OnChangeFn,
} from './types'

// Re-export useful TanStack utilities
export { createColumnHelper } from '@tanstack/react-table'
